import { motion, useReducedMotion } from 'motion/react';
import type { ReactNode } from 'react';

export function PageTransition({ children }: { children: ReactNode }) {
  const reduced = useReducedMotion();
  return (
    <motion.div
      initial={false}
      animate={{ opacity: 1 }}
      transition={{ duration: reduced ? 0 : 0.2, ease: [0.16, 1, 0.3, 1] }}
    >
      {!reduced && <motion.div className="route-curtain" initial={{ scaleY: 1 }} animate={{ scaleY: 0 }} exit={{ scaleY: 1 }} transition={{ duration: 0.62, ease: [0.76, 0, 0.24, 1] }} />}
      {children}
    </motion.div>
  );
}
